import { useEffect } from 'react'

export const useChatGptSessionCleanup = () => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem('chatgpt_session_id')
      console.log('AIPop: clearing session_id on page refresh')
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      localStorage.removeItem('chatgpt_session_id')
      console.log('AIPop: clearing session_id on unmount')
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])
}
